export const groupOptions = [
  { name: 'Group A', value: 'Group A' },
  { name: 'Group B', value: 'Group B' },
  { name: 'Group C', value: 'Group C' },
  { name: 'Group D', value: 'Group D' },
];
